import Resources from './Resources'
export default Resources
